import { Aliment } from "./Aliment";

export const AddAlimentFormTemplate = Object.freeze({
  sections: [
    {
      size: 7 / 12,
      compact: true,
      inputs: [
        Aliment.food_name.composedElements.nameES,
        Aliment.food_name.composedElements.nameEN,
        Aliment.food_name.composedElements.nameFR,
        Aliment.food_type,
        Aliment.suited_meal,
      ],
    },
    {
      title: "Características adicionales",
      size: 1 / 2,
      compact: true,
      inputs: [
        Aliment.season,
        Aliment.kcal,
        Aliment.net_weight,
        Aliment.co2,
        Aliment.home_measure,
        Aliment.home_quantity,
        Aliment.avoid_diet_pref,
        Aliment.avoid_diet_cond,
        Aliment.workout_meal,
        Aliment.workout_exclusive,
        Aliment.intraworkout_exclusive,
        Aliment.avoid_preworkout,
        Aliment.rep_food,
        Aliment.unit_weight,
      ],
    },
    {
      title: "Macronutrientes y líquidos",
      size: 1 / 3,
      compact: true,
      inputs: [
        Aliment.h2O,
        Aliment.proteins,
        Aliment.fat,
        Aliment.fat_SFAs,
        Aliment.fat_MUFA,
        Aliment.fat_PUFA,
        Aliment.fat_cholest,
        Aliment.fat_omg3,
        Aliment.fat_omg6,
        Aliment.carbohidrates,
        Aliment.ch_simple,
        Aliment.ch_starch,
        Aliment.fiber,
        Aliment.fib_soluble,
        Aliment.fib_insoluble,
      ],
    },
    {
      title: "Vitaminas y carótenos",
      size: 1 / 3,
      compact: true,
      inputs: [
        Aliment.a_vitam,
        Aliment.a1_vitam,
        Aliment.b1_vitam,
        Aliment.b2_vitam,
        Aliment.b3_vitam,
        Aliment.b5_vitam,
        Aliment.b6_vitam,
        Aliment.b7_vitam,
        Aliment.b9_vitam,
        Aliment.b12_vitam,
        Aliment.c_vitam,
        Aliment.d_vitam,
        Aliment.e_vitam,
        Aliment.k_vitam,
        Aliment.carotenes,
      ],
    },
    {
      title: "Minerales",
      size: 1 / 4,
      compact: true,
      inputs: [
        Aliment.salt,
        Aliment.calcium,
        Aliment.iron,
        Aliment.iodine,
        Aliment.magnesium,
        Aliment.zinc,
        Aliment.sodium,
        Aliment.potassium,
        Aliment.phosphorus,
        Aliment.selenium,
        Aliment.copper,
        Aliment.chromium,
        Aliment.nickel,
        Aliment.chlorine,
        Aliment.fluorine,
        Aliment.manganese,
      ],
    },
  ],
});
